<template>
<div class="chapter">
<div class="inner_page">
<p class="calibre2"><br/>
<br/>
<br/>
<br/>
<br/>
<br/>
<br/>
<br/>
<br/>
<br/>
<br/></p>
<p class="calibre2">Published by Rowman &amp; Littlefield Publishers, Inc.<br/>
  A wholly owned subsidiary of The Rowman &amp; Littlefield Publishing Group, Inc.<br/>
  4501 Forbes Boulevard, Suite 200, Lanham, Maryland 20706<br/>
<a href="http://www.rowmanlittlefield.com" target="_blank">http://www.rowmanlittlefield.com</a></p>
<p class="calibre2">Estover Road, PlymouthPL6 7PY, United Kingdom</p>
<p class="calibre2">Copyright © 2012 by Rowman &amp; Littlefield Publishers, Inc.</p>
<p class="calibre2"><i class="calibre4">All rights reserved</i>. No part of this book may be reproduced in any form or by any electronic or mechanical means, including information storage and retrieval systems, without written permission from the publisher, except by a reviewer who may quote passages in a review.</p>
<p class="calibre2">British Library Cataloguing in Publication Information Available</p>
<p class="calibre2 calibre3">Library of Congress Cataloging-in-Publication Data</p>
<p class="calibre2">Kramer, Kenneth, 1941–<br/>
<span class="indent1">Martin Buber’s spirituality : Hasidic wisdom for everyday life / Kenneth Paul Kramer.</span><br/>
<span class="indent2">p. cm.</span><br/>
<span class="indent1">Includes bibliographical references (p. ) and index.</span><br/>
<span class="indent1">ISBN 978-1-4422-1367-8 (cloth : alk. paper)—ISBN 978-1-4422-1369-2 (electronic)</span><br/>
<span class="indent1">1. Spiritual life—Judaism. 2. Hasidim—Quotations. 3. Hasidism—Quotations,</span><br/>
  maxims, etc. 4. Buber, Martin, 1878–1965. I. Title.<br/>
<span class="indent1">BM723.K73 2012</span><br/>
<span class="indent1">296.7—dc23</span> <span class="indent3">2011029154</span></p>
<p class="calibre2"><img alt="image" src="Images/frn_fig_004.png"/> The paper used in this publication meets the minimum requirements of American National Standard for Information Sciences—Permanence of Paper for Printed Library Materials, ANSI/NISO Z39.48-1992.</p>
<p class="calibre2">Printed in the United States of America</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Copyright.vue?149d6e76